import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalWindowParameters} from '../../modal-window-parameters';
import {ModalWindowResponse} from '../../modal-window-response';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-modal-window-checklist',
  templateUrl: './modal-window-checklist.component.html',
  styleUrls: ['./modal-window-checklist.component.scss']
})
export class ModalWindowChecklistComponent implements OnInit {

  @Input() modalWindowParameters: ModalWindowParameters;
  @Output() modalWindowResponse: EventEmitter<ModalWindowResponse> = new EventEmitter<ModalWindowResponse>();
  formGroup: FormGroup;

  constructor(
    protected formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    const formGroupConfig: any = {};
    this.modalWindowParameters.checklist.forEach(
      checkbox => formGroupConfig[checkbox.name] = this.formBuilder.control(checkbox.value)
    );
    this.formGroup = this.formBuilder.group(formGroupConfig);
  }
  onCancelClick() {
    this.modalWindowResponse.next({confirmed: false});
  }
  onApplyClick() {
    this.modalWindowResponse.next({confirmed: true, checklistResult: this.formGroup.value});
  }
}
